export function normalizeSellerHandle(value) {
  return String(value || '').trim().replace(/^@+/, '');
}

/** Avoid showing the same handle twice when name and username match. */
export function getSellerIdentityLabels(name) {
  const displayName = normalizeSellerHandle(name);

  if (!displayName) {
    return { primary: null, secondary: null };
  }

  return { primary: displayName, secondary: null };
}
